import React from 'react';
import { withRouter } from 'react-router';
import { Box, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import { GET_MEMBERSHIPS } from '../../../graphql';
import withSession from '../../../lib/withSession';
import reportIcon from '../../../static/reportIcon.png';
import kitIcon from '../../../static/kitIcon.png';
import nutritionistDashIcon from '../../../static/nutritionistDashIcon.png';
import Medication from '../../../static/Medication.png';
import { Skeleton } from '../../../components/loadingSkeleton/Skeleton';
import PleaseWait from '../../../components/PleaseWait';

import ShareImage from '../../../static/shareImage.png';
import OrderSIBO from '../../../static/OrderSIBO.png';
import { Query } from 'react-apollo';
import { isToggleActive } from '../../../components/featureToggle/toggles';
import { useEffect } from 'react';
import withAnalytics from '../../../lib/withAnalytics';

const Card = styled(Flex)`
  background: white;
  border-radius: 10px;
  box-shadow: 5px 10px 50px rgba(0, 0, 0, 0.07);
  flex-direction: column;
  padding: 14px 10px;
  margin-right: 14px;
  width: 126px;
  max-width: 126px;
  height: 138px;
  max-height: 138px;
  overflow: hidden;
`;
const ServicesContainer = styled(Flex)`
  transition: 0.3s all ease-in-out;
  overflow-x: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding-bottom: 24px;
  &::-webkit-scrollbar {
    display: none;
  }
  & > * {
    transition: 0.3s all ease-in-out;
  }
  &:hover > * {
    opacity: 0.5;
  }
  &:hover > :hover {
    opacity: 1;
  }

  @media screen and (max-width: 480px) {
    margin-left: -20px;
    margin-right: -20px;
    padding-bottom: 24px;
    &:hover > * {
      opacity: 1;
    }
  }
`;

const VirtualPadder = styled(Box)`
  width: 20px;
  min-width: 20px;
  @media screen and (min-width: 480px) {
    display: none;
  }
`;

const Container = styled(Flex)`
  width: 100%;
  max-width: 700px;

  @media screen and (max-width: 480px) {
    width: 100vw;
    max-width: 100vw;
    padding: 0 20px;
    overflow-x: hidden;
  }
`;

const LoadingCard = () => {
  return (
    <ServiceCard style={{ flexDirection: 'column', padding: '8px', opacity: 0.5 }}>
      <Flex flex={1} alignItems="center" justifyContent={'center'} style={{}}>
        <PleaseWait
          text={' '}
          spinner={{
            sColor: '#ECEFF2',
            pColor: '#909FB5',
          }}
        />
      </Flex>
      <Flex alignItems={'center'} justifyContent="center">
        <Skeleton width="75px" height="22px" />
      </Flex>
    </ServiceCard>
  );
};

const ServiceCard = styled(Card)`
  width: 126px;
  min-width: 126px;
  flex: initial;
`;

const ServiceAvailable = withAnalytics(({ history, session, loadingAppointments, hasFutureAppointmentsNutritionist, analytics }) => {
  return (
    <>
      <ConnectWithProvider history={history} loading={loadingAppointments} hasFutureAppointmentsNutritionist={hasFutureAppointmentsNutritionist} analytics={analytics} session={session} />

      <ServiceAvailableInner history={history} session={session} />
    </>
  );
});

const ConnectWithProvider = ({ history, data, loading, hasFutureAppointmentsNutritionist, loadingAppointments, analytics, session }) => {
  const { email, firstName, lastName } = session;
  const name = encodeURI(`${firstName} ${lastName}`);
  let url = `https://calendly.com/paloma-video-visit/gut-reset?hide_event_type_details=1&name=${name}&email=${email}`;

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;

    document.body.appendChild(script);
  });
  
  return (
    <Container flexDirection="column" mt="32px">
      <Heading mb="32px">Connect With Your Provider</Heading>
      {!!loadingAppointments || !!loading ? (
        <ServicesContainer flexDirection={'row'}>
          <VirtualPadder />
          {[1, 2, 3, 4].map((x) => {
            return <LoadingCard />;
          })}
          <VirtualPadder />
        </ServicesContainer>
      ) : (
        <ServicesContainer flexDirection="row">
          <VirtualPadder />
          <ServiceCard style={{ cursor: 'pointer' }} onClick={() => history.push('/programs/gut-reset-communicator')}>
            <Flex flex={1} alignItems="center" justifyContent={'center'} style={{ marginTop: '-20px' }}>
              <img src={ShareImage} style={{ height: '83px' }} />
            </Flex>
            <Text textAlign={'center'} fontSize="14px">
              Message your provider
            </Text>
          </ServiceCard>
          {!hasFutureAppointmentsNutritionist && (
            <ServiceCard
              style={{ cursor: 'pointer' }}
              onClick={() => {
                window.Calendly.initPopupWidget({
                  url,
                });
                if (!!analytics) {
                  analytics.track('Book GI nutritionist consultation');
                }
              }}
            >
              <Flex flex={1} alignItems="center" justifyContent={'center'} style={{ marginTop: '-10px', marginBottom: '-10px', overflow: 'hidden' }}>
                <img src={nutritionistDashIcon} style={{ height: '100%' }} />
              </Flex>
              <Text textAlign={'center'} fontSize="14px">
                Schedule a nutritionist visit
              </Text>
            </ServiceCard>
          )}
          <VirtualPadder />
        </ServicesContainer>
      )}
    </Container>
  );
};

const ServiceAvailableInner = ({ history }) => {
  return (
    <Container flexDirection="column" mt="32px">
      <Heading mb="32px">Your Gut Insights Toolkit</Heading>
      <ServicesContainer flexDirection="row">
        <VirtualPadder />
        <ServiceCard style={{ cursor: 'pointer' }} onClick={() => history.push('/uploadGiLabResults')}>
          <Flex flex={1} alignItems="center" justifyContent={'center'} style={{ marginTop: '-20px' }}>
            <img src={reportIcon} style={{ height: '63px' }} />
          </Flex>
          <Text textAlign={'center'} fontSize="14px">
            Upload your GI test results
          </Text>
        </ServiceCard>

        <ServiceCard
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.open('https://foodmarble.com/store?discount_code=PALOMA', '_blank');
          }}
        >
          <Flex flex={1} alignItems="center" justifyContent={'center'} style={{ marginTop: '-20px' }}>
            <img src={OrderSIBO} />
          </Flex>
          <Text textAlign={'center'} fontSize="14px">
            Order a GI Breath test
          </Text>
        </ServiceCard>

        <ServiceCard
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.open('https://bit.ly/48Y92Hw', '_blank');
          }}
        >
          <Flex flex={1} alignItems="center" justifyContent={'center'} style={{ marginTop: '-20px', marginBottom: '-20px', overflow: 'hidden' }}>
            <img src={kitIcon} style={{ height: '100%' }} />
          </Flex>
          <Text textAlign={'center'} fontSize="14px">
            Buy another GI test
          </Text>
        </ServiceCard>
        <VirtualPadder />
      </ServicesContainer>
    </Container>
  );
};

export default withSession(withRouter(ServiceAvailable));
